const resolveBaseUrl = (envKey, productionUrl, localUrl) => {
  const envValue = typeof process !== 'undefined' && process.env ? process.env[envKey] : undefined;
  if (envValue && envValue.trim().length > 0) {
    return envValue.trim();
  }

  if (typeof window !== 'undefined') {
    const storedOverride = window.sessionStorage?.getItem(envKey) || window.localStorage?.getItem(envKey);
    if (storedOverride && storedOverride.trim().length > 0) {
      return storedOverride.trim();
    }

    const host = window.location?.hostname ?? '';
    if (/(^localhost$)|(^127\.0\.0\.1$)|(^0\.0\.0\.0$)/.test(host)) {
      return localUrl;
    }
  }

  return productionUrl;
};

export const BASE_HAUTH_URL = resolveBaseUrl('VUE_APP_BASE_HAUTH_URL', 'https://sec-hauth.azurewebsites.net', 'https://sec-hauth.azurewebsites.net');
export const BASE_HSUITE_URL = resolveBaseUrl('VUE_APP_BASE_HSUITE_URL', 'https://sec-hsuite.azurewebsites.net', 'http://localhost:5078');

export const SYSTEM_VERSION = 'ElisaUI - Prod v1.0';
